import { TextIcon } from "../../../CommonUI/TextIcon";
import React from "react";
import { BaseJSONXMLElementEditor } from "./BaseJSONXMLElementEditor";
import { JSONXMLDateElement } from "../../../rule-engine-core/TextMerge/Elements/JSONXML/JSONXMLDateElement";

export class JSONXMLDateEditor extends BaseJSONXMLElementEditor<JSONXMLDateElement> {
    getIcon(): JSX.Element {
        return <TextIcon name={"7/2"} />;
    }
}
